/** saves Accounts Balances
@payload { Array } https://issue.inm.pt/projects/c04401-banco-mais-middleware-integracao/wiki/GET_accountsbalances
*/
export const SAVE_ACCOUNTS_BALANCE = (state, payload) => {
    state.accountsBalances = payload.balanceViews
}

/** Clears all state for this feature to make sure we have a clean state when entering feature
* this also makes our app lighter and faster
*/
export const CLEAR_CHARGE_DP_STATES = (state, payload) => {
    state.accountsBalances = []
}
